<template lang="pug">
  .controls
    ul.controls__buttons
      li.controls__button(
        v-for="item in items",
        :class="'controls__button_' + item",
        v-html="item === 'space' ? '' : item === 'left' ? 'Влево' : 'Вправо'")
</template>

<script>
export default {
  name: 'Controls',
  data() {
    return {
      items: [
        'left',
        'right',
        'space',
      ],
    };
  },
};
</script>

<style scoped lang="scss">
  $space-height: 36px;
  $space-width: 234px;
  $controls-width: 400px;

  .controls {
    display: flex;
    justify-content: center;
    margin: 18px 0 0;
    &__button {
      @include typo-text;
      color: $clr-blue;
      text-transform: capitalize;
      display: flex;
      align-items: center;
      flex: 0 0 50%;
      @media (max-width: $max-width-xs) {
        @include typo-p(normal);
      }
      &_left {
        justify-content: flex-end;
        &:after {
          @include pseudo($pos: relative);
          @include retina-sprite($button-left-group);
          margin-left: 52px;
          margin-right: 6px;
          @media (-moz-touch-enabled: 1),
            (pointer: coarse) {
            @include retina-sprite($button-left-xs-group);
            margin-right: 10px;
          }
          @media (max-width: $max-width-xs) {
            margin-left: 15px;
          }
        }
      }
      &_right {
        justify-content: flex-start;
        &:before {
          @include pseudo($pos: relative);
          @include retina-sprite($button-right-group);
          margin-right: 52px;
          margin-left: 6px;
          @media (-moz-touch-enabled: 1),
            (pointer: coarse) {
            @include retina-sprite($button-right-xs-group);
            margin-left: 10px;
          }
          @media (max-width: $max-width-xs) {
            margin-right: 14px;
          }
        }
      }
      &_space {
        height: $space-height;
        border: 4px solid $clr-middleBlue;
        flex: 0 0 $space-width;
        margin: 20px 0 0;
        @media (-moz-touch-enabled: 1),
          (pointer: coarse) {
          border: none;
          flex: 0 0 auto;
          height: auto;
          margin: 3px 0 0;
          @include retina-sprite($button-space-xs-group);
        }
      }
      &s {
        @include nl;
        display: flex;
        flex-flow: row wrap;
        align-items: flex-end;
        justify-content: center;
        flex: 0 0 $controls-width;
      }
    }
    & + .rules__text {
      margin: 12px 0 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/UI/Controls.vue